import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Goatopunetaxi() {



const cardData =
{
  keyword: 'Goa to Pune Taxi  ',

  heading: 'Lotus Cab: Goa to Pune Taxi  ',

headingDescription:
  "Lotus Cabs offers dependable and affordable Goa to Pune Taxi services for family travel, corporate trips, business meetings, airport transfers, student travel, holiday tours, weekend getaways, and one-way or round-trip journeys. Our premium fleet features Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus, all driven by professional and experienced chauffeurs. With 24x7 booking support, transparent pricing, doorstep pickup from any location in Goa, clean and well-maintained vehicles, and a commitment to safe long-distance travel, Lotus Cabs ensures a smooth, comfortable, and hassle-free taxi journey from Goa to Pune.",


  top: 'Top Places to Visit in Pune before Traveling to Goa with Lotus Cab',

topPlaces: [

    {
        title: "Saras Baug",
        description:
            "Saras Baug is a beautiful public garden famous for its lush greenery and the historic Siddhivinayak Temple situated at its center. It is a favorite spot for families, joggers, and visitors looking to relax amidst nature in the heart of Pune."
    },
    {
        title: "Vetal Tekdi",
        description:
            "Vetal Tekdi is the highest hill in Pune and a paradise for nature lovers, trekkers, and fitness enthusiasts. The hill offers scenic walking trails, fresh air, abundant greenery, and spectacular sunrise and sunset views over the city."
    },
        {
        title: "Lal Mahal",
        description:
            "Lal Mahal is one of Pune's most historically significant landmarks, built by Shahaji Maharaj for Jijabai and young Chhatrapati Shivaji Maharaj. The reconstructed palace showcases important moments from Maratha history through beautiful exhibits and sculptures, making it a popular destination for history enthusiasts."
    },
    {
        title: "Parvati Hill Temple",
        description:
            "Parvati Hill Temple is a renowned hilltop temple complex dedicated to Lord Shiva and Goddess Parvati. Visitors climb over 100 steps to enjoy panoramic views of Pune city, peaceful surroundings, and the historical temples built during the Peshwa era."
    },
    {
        title: "Empress Garden",
        description:
            "Empress Garden is a sprawling botanical garden featuring colorful flowers, rare plant species, landscaped lawns, and peaceful walking paths. It is an ideal destination for picnics, photography, and enjoying nature with family and friends."
    },
    {
        title: "Okayama Friendship Garden",
        description:
            "Okayama Friendship Garden, also known as Pune-Okayama Garden, is a beautifully landscaped Japanese-style garden inspired by the famous Korakuen Garden of Japan. Its ponds, bridges, waterfalls, and manicured lawns create a calm and refreshing atmosphere."
    },
    {
        title: "National War Memorial Southern Command",
        description:
            "The National War Memorial Southern Command honors the brave soldiers of the Indian Armed Forces who sacrificed their lives for the nation. Featuring military displays, monuments, and informative exhibits, it is an inspiring destination for visitors interested in India's military history."
    },
    {
        title: "Pune-Okayama Garden",
        description:
            "Pune-Okayama Garden is a serene landscaped park known for its Japanese-inspired architecture, flowing streams, decorative bridges, and lush greenery. The garden provides a peaceful retreat for morning walks, photography, and relaxation."
    },
    {
        title: "Katraj Lake",
        description:
            "Katraj Lake is a tranquil freshwater lake surrounded by scenic hills and natural beauty. Visitors often come here for peaceful evening walks, birdwatching, and enjoying the calm atmosphere away from the city's busy streets."
    },
    {
        title: "Chaturshringi Temple",
        description:
            "Chaturshringi Temple is one of Pune's most revered Hindu temples dedicated to Goddess Chaturshringi. Located on a hillside, the temple is especially crowded during Navratri and offers beautiful views of the surrounding city along with a spiritually uplifting experience."
    }
],





"services": [
  {
    "name": "Goa to Pune Taxi",
    "description": "Book a Goa to Pune taxi for comfortable and reliable intercity travel with professional drivers and well-maintained vehicles."
  },
  {
    "name": "Goa to Pune Taxi Service",
    "description": "Professional Goa to Pune taxi service offering safe, convenient, and affordable transportation for families, tourists, and business travelers."
  },
  {
    "name": "Goa to Pune Cab",
    "description": "Comfortable Goa to Pune cab service with flexible pickup options and a wide range of vehicles for long-distance travel."
  },
  {
    "name": "Goa to Pune Cab Service",
    "description": "Reliable Goa to Pune cab service featuring AC vehicles, transparent pricing, and experienced chauffeurs."
  },
  {
    "name": "Goa to Pune Taxi Booking",
    "description": "Easy Goa to Pune taxi booking with instant confirmation, multiple vehicle choices, and dependable customer support."
  },
  {
    "name": "Goa to Pune Cab Booking",
    "description": "Convenient Goa to Pune cab booking service with quick reservations and hassle-free travel arrangements."
  },
  {
    "name": "Goa to Pune One Way Taxi",
    "description": "Affordable Goa to Pune one way taxi service allowing passengers to pay only for a single-side journey."
  },
  {
    "name": "Goa to Pune Round Trip Taxi",
    "description": "Flexible Goa to Pune round trip taxi packages suitable for family vacations, business visits, and weekend trips."
  },
  {
    "name": "Goa to Pune Outstation Taxi",
    "description": "Reliable Goa to Pune outstation taxi service for comfortable long-distance travel with professional drivers."
  },
  {
    "name": "Goa to Pune Airport Taxi",
    "description": "Convenient Goa to Pune airport taxi service with timely pickup from Goa airports and direct transfer to Pune."
  },
  {
    "name": "Goa to Pune Private Taxi",
    "description": "Private Goa to Pune taxi service offering exclusive travel experience with flexible schedules and premium comfort."
  },
  {
    "name": "Goa to Pune Sedan Taxi",
    "description": "Comfortable Goa to Pune sedan taxi service ideal for solo travelers, couples, and small families."
  },
  {
    "name": "Goa to Pune Innova Taxi",
    "description": "Spacious Goa to Pune Innova taxi service perfect for family trips and group travel with ample luggage space."
  },
  {
    "name": "Goa to Pune Ertiga Taxi",
    "description": "Affordable Goa to Pune Ertiga taxi service with comfortable seating and economical fares for small groups."
  },
  {
    "name": "Goa to Pune Taxi Fare",
    "description": "Get transparent Goa to Pune taxi fare details with clear pricing based on vehicle type, tolls, and travel distance."
  },
  {
    "name": "Goa to Pune Taxi Price",
    "description": "Check Goa to Pune taxi price options for sedans, SUVs, and premium vehicles with no hidden charges."
  },
  {
    "name": "Goa to Pune AC Taxi",
    "description": "Travel comfortably with Goa to Pune AC taxi service featuring air-conditioned vehicles and experienced drivers."
  },
  {
    "name": "Goa to Pune Family Taxi",
    "description": "Comfortable Goa to Pune family taxi service with spacious vehicles suitable for family and group travel."
  },
  {
    "name": "Best Goa to Pune Taxi Service",
    "description": "Best Goa to Pune taxi service offering professional drivers, clean vehicles, timely pickups, and excellent customer support."
  },
  {
    "name": "Affordable Goa to Pune Taxi",
    "description": "Budget-friendly Goa to Pune taxi service providing comfortable travel at competitive prices without compromising quality."
  }
],

"tableData": [
  ["Goa to Pune Taxi", "Goa to Pune Taxi Service"],
  ["Goa to Pune Cab", "Goa to Pune Cab Service"],
  ["Goa to Pune Taxi Booking", "Goa to Pune Cab Booking"],
  ["Goa to Pune One Way Taxi", "Goa to Pune Round Trip Taxi"],
  ["Goa to Pune Outstation Taxi", "Goa to Pune Airport Taxi"],
  ["Goa to Pune Private Taxi", "Goa to Pune Sedan Taxi"],
  ["Goa to Pune Innova Taxi", "Goa to Pune Ertiga Taxi"],
  ["Goa to Pune Taxi Fare", "Goa to Pune Taxi Price"],
  ["Goa to Pune AC Taxi", "Goa to Pune Family Taxi"],
  ["Best Goa to Pune Taxi Service", "Affordable Goa to Pune Taxi"]
],






"whychoose": [
  {
    "WhyChooseheading": "Reliable Intercity Taxi Service",
    "WhyChoosedescription": "Travel comfortably from Goa to Pune with dependable and professionally managed taxi services."
  },
  {
    "WhyChooseheading": "Budget-Friendly Pricing",
    "WhyChoosedescription": "Competitive taxi fares with transparent billing and no hidden charges."
  },
  {
    "WhyChooseheading": "Variety of Vehicle Options",
    "WhyChoosedescription": "Choose from Sedan, Ertiga, Innova Crysta, and SUVs for a convenient journey."
  },
  {
    "WhyChooseheading": "Pickup from Any Location in Goa",
    "WhyChoosedescription": "Get picked up directly from airports, hotels, resorts, railway stations, or your doorstep."
  },
  {
    "WhyChooseheading": "Comfortable Long-Distance Travel",
    "WhyChoosedescription": "Well-maintained AC taxis ensure a pleasant and relaxing trip to Pune."
  },
  {
    "WhyChooseheading": "Professional and Courteous Drivers",
    "WhyChoosedescription": "Experienced chauffeurs make your highway journey safe, smooth, and enjoyable."
  },
  {
    "WhyChooseheading": "Flexible Travel Schedule",
    "WhyChoosedescription": "Book your taxi according to your preferred pickup time and travel plans."
  },
  {
    "WhyChooseheading": "24x7 Customer Support",
    "WhyChoosedescription": "Dedicated assistance available anytime for booking, fare details, and travel support."
  }
]
};

const faqData = [
  {
    question: 'Does Lotus Cab provide Goa to Pune taxi service?',
    answer: 'Yes, Lotus Cab offers reliable Goa to Pune taxi services for one-way transfers, round trips, and customized travel requirements.'
  },
  {
    question: 'What is the road distance between Goa and Pune?',
    answer: 'The distance from Goa to Pune is approximately 450 km, and the journey generally takes around 8 to 10 hours.'
  },
  {
    question: 'How much does a Goa to Pune taxi cost?',
    answer: 'Taxi fares depend on the selected vehicle, travel date, and trip type. Lotus Cab provides affordable pricing with complete transparency.'
  },
  {
    question: 'Can I book a one-way taxi from Goa to Pune?',
    answer: 'Yes, we offer economical one-way taxi services that allow passengers to travel without paying unnecessary return charges.'
  },
  {
    question: 'Which vehicles are available for Goa to Pune taxi booking?',
    answer: 'Our fleet includes Sedan cars, Ertiga, Innova Crysta, and spacious SUVs suitable for all types of travelers.'
  },
  {
    question: 'Do you provide pickup from Goa Airport?',
    answer: 'Yes, Lotus Cab offers taxi pickups from Goa Airport, railway stations, hotels, and other major locations.'
  },
  {
    question: 'Are toll and parking charges included in the taxi fare?',
    answer: 'Toll charges, parking fees, and state taxes are generally charged separately unless specifically mentioned in the package.'
  },
  {
    question: 'Can I travel overnight from Goa to Pune?',
    answer: 'Yes, our taxi service operates day and night, providing safe and comfortable long-distance travel.'
  },
  {
    question: 'Is advance booking available for Goa to Pune taxis?',
    answer: 'Yes, you can reserve your taxi in advance to ensure vehicle availability and a hassle-free travel experience.'
  },
  {
    question: 'How can I book a Goa to Pune Taxi with Lotus Cab?',
    answer: 'Simply share your pickup location, travel date, preferred vehicle, and passenger details to receive an instant quotation and booking confirmation.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Nikhil Sawant',
    feedback: 'Our return journey from Goa was perfectly managed by Lotus Cab. The taxi arrived on time, and the driver made sure we had a comfortable ride all the way to Pune.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Kavya Mehta',
    feedback: 'I needed a direct taxi from Goa to Pune after a business trip, and the service exceeded my expectations. Clean vehicle, polite driver, and a smooth highway journey.',
    rating: 5,
  },
];









































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];









const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Goa to Pune Taxi",
"image": "https://lotuscab.com/assets/images/goa-to-pune-taxi.jpg",
"description": "Book Goa to Pune Taxi with Lotus Cab for safe, comfortable, and reliable outstation travel. Get premium taxi services for one way trips, round trips, airport transfers, and family travel with sedan, Innova, and private cabs available 24x7 with professional drivers.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "7215"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹18/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/goa-to-pune-taxi"
}
};





  return (
    <div>
      

<Helmet>
  <title>Goa to Pune Taxi | One Way & Outstation Cab Service | +91 8767592195</title>

<meta
 name="description"
 content="Book Goa to Pune Taxi with Lotus Cab for affordable and comfortable travel. Get one way, round trip, airport, and outstation taxi services with sedan, Innova, and private cabs driven by professional drivers available 24x7."
/>

<meta
 name="keywords"
 content="Goa to Pune Taxi, Goa to Pune Taxi Service, Goa to Pune Cab, Goa to Pune Cab Service, Goa to Pune Taxi Booking, Goa to Pune Cab Booking, Goa to Pune One Way Taxi, Goa to Pune Round Trip Taxi, Goa to Pune Outstation Taxi, Goa to Pune Airport Taxi, Goa to Pune Private Taxi, Goa to Pune Sedan Taxi, Goa to Pune Innova Taxi"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>







 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/95.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Goatopunetaxi;